// Single source of truth for "what name should we show for this user?"
// Anon users have a CamelCase handle (BluePanda42); claimed users may
// have a custom username and an optional preserved handle. Always
// prefer handle when present so display stays stable across claim.

export interface UserLike {
  handle?: string | null;
  username?: string | null;
}

export const displayHandle = (u: UserLike | null | undefined): string =>
  (u && (u.handle ?? u.username)) || '';
